import { useRef, useState, useEffect } from "react";
import { Typography, Box, IconButton, Button } from "@mui/material";
import { UnControlled as CodeMirror } from "react-codemirror2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";

import "../codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/theme/neo.css";

require("codemirror/mode/javascript/javascript");

function ResponseCode(props) {
  const editor = useRef();
  const wrapper = useRef();

  const [showMore, setShowMore] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [lines, setLines] = useState(0);

  const editorWillUnmount = () => {
    if (editor && wrapper?.current?.hydrated) {
      editor.current.display.wrapper.remove();
      wrapper.current.hydrated = false;
    }
  };

  const handleShowMore = () => {
    setShowMore((prevState) => !prevState);
  };

  useEffect(() => {
    const parentElement = document.querySelector(".response-codemirror");
    if (parentElement) {
      const childElement = parentElement.querySelector(".CodeMirror-scroll");
      if (childElement && showMore) {
        childElement.style.height = "100%"; // Change the height to your desired value
      }

      if (childElement && !showMore) {
        childElement.style.height = "215px"; // Change the height to your desired value
      }
    }
  }, [showMore]);

  useEffect(() => {
    if (props.code) {
      //const lines = props.code.split("\n").length;
      const jsonObject = JSON.parse(props.code);
      const prettyPrintedJSONString = JSON.stringify(jsonObject, null, 4);
      const jsonLines = prettyPrintedJSONString.split(/\r?\n/);

      setLines(jsonLines.length);
      //setLines(lines);

      const parentElement = document.querySelector(".response-codemirror");
      if (parentElement) {
        const childElement = parentElement.querySelector(".CodeMirror-scroll");
        if (childElement && jsonLines.length < 12) {
          childElement.style.height = "100%"; // Change the height to your desired value
        }
      }
    }
  }, [props.code]);

  return (
    <div
      style={{
        width: "100%",
        background: "rgb(247 247 247)",
        //padding: "10px 15px 19px 15px",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "5px",
      }}
    >
      <Box
        className="codeBox-banner"
        sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
      >
        <Typography className="label-caps" sx={{ color: "#c37f7f !important" }}>
          {props.type}
        </Typography>

        <IconButton
          onClick={() => props.copyFn(JSON.parse(props.code))}
          aria-label="delete"
          className="black-icon-button"
          size="small"
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>

      <CodeMirror
        className="response-codemirror"
        value={JSON.stringify(JSON.parse(props.code), null, 2)}
        ref={wrapper}
        options={{
          mode: { name: "javascript", json: true },
          theme: "default",
          lineNumbers: true,
        }}
        editorDidMount={(e) => (editor.current = e)}
        editorWillUnmount={editorWillUnmount}
      />

      <Box
        className="codeBox-banner"
        sx={{ borderTop: "1px solid rgba(0, 0, 0, 0.1)" }}
        justifyContent="center"
        alignItems="center"
      >
        <Button
          sx={{ visibility: lines > 12 ? "visible" : "hidden" }}
          onClick={handleShowMore}
          endIcon={!showMore ? <UnfoldMoreIcon /> : <UnfoldLessIcon />}
          className="show-more-btn-response"
          size="small"
        >
          Show {!showMore ? "more" : "less"}
        </Button>
      </Box>
    </div>
  );
}

export default ResponseCode;
